"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactHelmet = _interopRequireDefault(require("react-helmet"));

var _pageMetadata = require("../../models/page-metadata");

var _metaTags = _interopRequireDefault(require("./util/meta-tags"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Render a React Helmet component to build a rich set of metadata into the
 * page's <head>. Values deeper down the component tree override higher ones,
 * so this can easily be used to create and then override default values
 * throughout the page.
 * This does not render any directly displayed markup.
 * Page Metadata model in Contentful:
 *    https://app.contentful.com/spaces/ljtyf78xujn2/content_types/pageMetadata/fields
 */
var PageMetadata = function PageMetadata(props) {
  var pageTitle = props.pageTitle,
      shareTitle = props.shareTitle,
      description = props.description,
      primaryImage = props.primaryImage,
      twitterCard = props.twitterCard,
      twitterSite = props.twitterSite,
      additionalMetadata = props.additionalMetadata,
      pageTitleText = props.pageTitleText,
      metaDescription = props.metaDescription,
      jsonLd = props.jsonLd; // MetaTags literally handles <meta> tags. This includes the official
  // page description <meta name="description".../> as well as OpenGraph and
  // Twitter metadata tags e.g. <meta name="twitter:title".../> but, notably,
  // does not include the <title> tag, which are handed to Helmet separately.

  var meta = new _metaTags["default"]().title(shareTitle || pageTitle || pageTitleText) // (og|twitter):title
  .description(description || metaDescription).image(primaryImage && primaryImage.url).openGraph('image:width', primaryImage && primaryImage.width).openGraph('image:height', primaryImage && primaryImage.height).twitter('card', twitterCard).twitter('site', twitterSite).pushAll(additionalMetadata);
  var jsonLdScript = jsonLd ? /*#__PURE__*/_react["default"].createElement("script", {
    type: "application/ld+json"
  }, JSON.stringify(jsonLd)) : null;
  return /*#__PURE__*/_react["default"].createElement(_reactHelmet["default"], {
    title: pageTitle || pageTitleText // The actual <title> tag on the page
    ,
    meta: meta.tags
  }, jsonLdScript);
};

PageMetadata.propTypes = _pageMetadata.interpretedMetadataPropType;
PageMetadata.defaultProps = {
  pageTitle: null,
  shareTitle: null,
  description: null,
  primaryImage: {
    url: null,
    width: null,
    height: null
  },
  openGraphType: null,
  twitterCard: null,
  twitterSite: null,
  additionalMetadata: [],
  pageTitleText: null,
  metaDescription: null,
  jsonLd: null
};
var _default = PageMetadata;
exports["default"] = _default;